app.controller("OnlineOfferSearchPageController",
	["$scope", "$timeout", "OnlineOfferSearchService", "OnlineOfferSearchModel", "BrowserStorageService", "AreaNaviService", function($scope, $timeout, OnlineOfferSearchService, OnlineOfferSearchModel, BrowserStorageService, AreaNaviService) {

		$scope.searchParameterChanged = false;
		$scope.searchAddressChanged = false;
		$scope.searchID = undefined;
		$scope.searchResults = OnlineOfferSearchService.results;
		$scope.autoSearching = false;


		$scope.Init = function(searchID) {
			$scope.searchID = searchID;
		};

		$scope.$watch('searchResults[searchID].loading', function(newVal) {
			if(newVal && typeof($scope.autoSearchTimeout) != 'undefined' && !$scope.autoSearching) {
				// Haku tehty muualta (todennäköisesti hakunappulasta), perutaan automaattinen haku
				$timeout.cancel($scope.autoSearchTimeout);
			}
		});

		$scope.LoadMore = function() {
			OnlineOfferSearchModel.queries[$scope.searchID].SetSkip(OnlineOfferSearchModel.queries[$scope.searchID].GetSkip() + OnlineOfferSearchModel.queries[$scope.searchID].GetResultLimit());
			OnlineOfferSearchService.RunQuery(OnlineOfferSearchModel.queries[$scope.searchID], $scope.searchID, true, function() {
			});
		};

		$scope.OnSearchParameterChanged = function(newValue, oldValue) {
			if(newValue == oldValue) {
				return;
			}

			if(typeof($scope.autoSearchTimeout) != 'undefined') {
				$timeout.cancel($scope.autoSearchTimeout);
			}
			$scope.searchParameterChanged = true;
			if (JSON.stringify(angular.copy(newValue.address)) != JSON.stringify(angular.copy(oldValue.address))) {
				AreaNaviService.setVisible(false);
				$scope.searchAddressChanged = true;
			}
			$scope.autoSearchTimeout = $timeout(function () {
				$scope.autoSearching = true;
				OnlineOfferSearchModel.queries[$scope.searchID].SetSkip(0);
				BrowserStorageService.LocalStorage.SetItem("OnlineOfferSearchQuery", OnlineOfferSearchModel.queries[$scope.searchID].GetAsStorageBlob());
				OnlineOfferSearchService.RunQuery(OnlineOfferSearchModel.queries[$scope.searchID], $scope.searchID, false, function() {
					//$("body").animate({ scrollTop: 0 }, "slow");
					$timeout.cancel($scope.autoSearchTimeout);
					$scope.autoSearching = false;
				});

			}, 1200);
		};

		OnlineOfferSearchService.AddNotificationListener('OnlineOfferSearchBarReady', function(data) {
			OnlineOfferSearchService.RunQuery(data.query, $scope.searchID, false);

			// Vahtaa hakuparametrejä
			$scope.$watch(function() { return OnlineOfferSearchModel.queries[$scope.searchID].GetConstraints(); }, function(newValue, oldValue) {
				$scope.OnSearchParameterChanged(newValue, oldValue);
			}, true);


		});


	}]
);